import React from "react";
import { Button as MUIButton } from "@mui/material";

const BackButton = ({ goBack: customOnclick }) => {
    const goBack = () => {
        window.history.go(-1);
    };

    return (
        <MUIButton color="primary" size="medium" onClick={customOnclick || goBack}>
            Back
        </MUIButton>
    );
};

export default BackButton;
